<template>
  <div :class="{ 'icon': true, 'is-selected': selected }">
    <div class="icon-inner">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Icon',

  props: {
    selected: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="sass">
.icon
  width: 12px
  height: 12px
  border: solid 1px #cbcbcb
  padding: 1px
  background: #fff
  &.is-selected
    border-color: #9d9d9d

.icon-inner
  width: 8px
  height: 8px
  background: #cbcbcb
</style>
